<template>
  <div class="basic-layout">
    <header class="layout-header">
      <slot name="header"></slot>
    </header>
    
    <main class="layout-content">
      <slot></slot>
    </main>

    <footer class="layout-footer">
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'BasicLayout'
}
</script>

<style lang="scss" scoped>
.basic-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .layout-header {
    flex: 0 0 auto;
  }

  .layout-content {
    flex: 1;
  }

  .layout-footer {
    flex: 0 0 auto;
  }
}
</style> 